export default class IntermediaryHasApplicationsError extends Error {
  constructor(
    readonly intermediaryId: string,
    readonly intermediaryName: string,
    message?: string,
  ) {
    super(message);
  }
}
